import { StyledTab, StyledTabs } from 'components/Common/MUIStyledComponents';
import React, { useState } from 'react';
import TabPanel from 'components/Common/TabPanel';
import AboutTab from './AboutTab';
import OutcomesTab from './OutcomesTab';
import LessonsTab from './LessonsTab';
import DocsTab from './Docs';

interface ICourseInfoProps {
  cur_course: any;
  user_status: any;
  activeProgress: any;
  cur_lesson: any;
  comingSoon: boolean;
  userHasBiteU: boolean;
}

const CourseInfo: React.FC<ICourseInfoProps> = (props: ICourseInfoProps) => {
  const { cur_course, user_status, activeProgress, comingSoon, userHasBiteU } = props;
  const [ tabValue, setTabValue ] = useState(0);
  // MANAGE TOP LEVEL TABS
  const tabChange = (e: any, newValue: number) => {
    setTabValue(newValue);
  };

  const a11yProps = (index: number) => {
    return {
      'id': `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  return (
    <div className='course-info-container'>
      <h1>{cur_course.name}</h1>
      <h2>{cur_course.blurb}</h2>
      <StyledTabs value={tabValue} onChange={tabChange} centered>
        <StyledTab label='About' {...a11yProps(0)} />
        <StyledTab label='Outcomes' {...a11yProps(1)} />
        <StyledTab label='Videos' {...a11yProps(2)} />
        <StyledTab label='Course Materials' {...a11yProps(3)} disabled={cur_course.guideLink.length === 0} />
      </StyledTabs>
      <TabPanel value={tabValue} index={0} className=''>
        <AboutTab desc={cur_course.description}/>
      </TabPanel>
      <TabPanel value={tabValue} index={1} className=''>
        <OutcomesTab outs={cur_course.outcomes}/>
      </TabPanel>
      <TabPanel value={tabValue} index={2} className='lessons-tab'>
        <LessonsTab cur_course={cur_course} user_status={user_status} activeProgress={activeProgress} comingSoon={comingSoon} userHasBiteU={userHasBiteU}/>
      </TabPanel>
      <TabPanel value={tabValue} index={3} className='documents-tab'>
        <DocsTab guide={cur_course.guideLink} useCase={cur_course.useCaseLink} assessment={cur_course.assessLink}/>
      </TabPanel>
    </div>
  );
};

export default CourseInfo;
